
export abstract class AppError {
  type: AppErrorType;
  message: string;
  cause: any;
}

export enum AppErrorType {
  SERVER_SIDE,
  CLIENT_SIDE
}
